import { makeQuestionBuilder } from './utils';

const preferenceQuestionBuilder = makeQuestionBuilder(
  'preference',
  'preferenceQuestion',
  'page.preference-questions',
);

export const preferenceQuestions = [
  {
    props: {
      name: 'mobility',
      details: true,
      progress: 0.99,
    },
  },
  {
    props: {
      name: 'language',
      details: false,
      secondaryOptions: {
        yes: [
          'mi',
          'zh',
          'fj',
          'fr',
          'de',
          'ja',
          'ko',
          'ms',
          'pt',
          'sm',
          'tl',
          'ta',
          'to',
          'other',
        ],
      },
      progress: 0.99,
    },
  },
  {
    props: {
      name: 'religion',
      details: true,
      progress: 0.99,
    },
  },
  {
    props: {
      name: 'culture',
      details: true,
      progress: 0.99,
    },
  },
  {
    props: {
      name: 'diet',
      details: true,
      progress: 0.99,
    },
  },
  {
    props: {
      name: 'other',
      details: true,
      progress: 0.99,
    },
  },
  {
    props: {
      name: 'prep',
      options: ['pick-up-from-hospital', 'pick-up-from-local-pharmacy', 'receive-by-mail'],
      progress: 0.99,
    },
  },
]
  // TODO: ideally we would do this at build time.
  .map(preferenceQuestionBuilder);
